/**
 * @description `마우스휠 동작을 가로 스크롤로 변경`
 */
export function handleWheelHorizontalScroll(event: WheelEvent) {
    const element = event.currentTarget as HTMLElement;

    const multiplier = event.deltaMode === 1 ? 40 : 1;
    const scrollAmount = event.deltaY * multiplier;
    element.scrollTo({
        left: element.scrollLeft + scrollAmount,
        behavior: 'auto',
    });
}
